import type { ServiceDetail } from "@shyne/shared/api";
import { ReadAllResponse, uuid } from "@/interfaces";
import { activeOrganizationIdIfAny } from "@/lib/active-organization";
import { api } from "@/lib/api";
import { TaskWorkflowGrouped } from "@/models/task-workflow.model";

export const toTaskWorkflowList = ({ id: service, checklist }: Pick<ServiceDetail, "id" | "checklist">): ReadAllResponse<TaskWorkflowGrouped> => ({
  data: checklist.map((category) => ({
    id: category.id,
    title: category.title,
    service,
    created_at: "",
    updated_at: "",
    tasks: category.tasks.map((task) => ({ id: task.id, title: task.title, category: category.id, service, created_at: "", updated_at: "" })),
  })),
  count: checklist.length,
});

export const TaskWorkflowRepository = {
  async getAll(service: uuid): Promise<ReadAllResponse<TaskWorkflowGrouped>> {
    return toTaskWorkflowList(await api.services.get(service, { actingOrganization: activeOrganizationIdIfAny() }));
  },
  async createCategory(service: uuid, title: string): Promise<ReadAllResponse<TaskWorkflowGrouped>> {
    return toTaskWorkflowList(await api.services.addChecklistCategory(service, { title }));
  },
  async createTask(service: uuid, category: uuid, title: string): Promise<ReadAllResponse<TaskWorkflowGrouped>> {
    return toTaskWorkflowList(await api.services.addChecklistTask(service, category, { title }));
  },
  async deleteCategory(service: uuid, category: uuid): Promise<ReadAllResponse<TaskWorkflowGrouped>> {
    return toTaskWorkflowList(await api.services.deleteChecklistCategory(service, category));
  },
  async deleteTask(service: uuid, task: uuid): Promise<ReadAllResponse<TaskWorkflowGrouped>> {
    return toTaskWorkflowList(await api.services.deleteChecklistTask(service, task));
  },
};
